import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import SocialProof from './components/SocialProof';
import VenueStrip from './components/VenueStrip';
import MeetAlex from './components/MeetAlex';
import WhyWVE from './components/WhyWVE';
import Portfolio from './components/Portfolio';
import VenueSearch from './components/VenueSearch';
import Pricing from './components/Pricing';
import VideoReviews from './components/VideoReviews';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import DateChecker from './components/DateChecker';
import Footer from './components/Footer';
import StickyMobileCTA from './components/StickyMobileCTA';
import ExitIntent from './components/ExitIntent';
import SocialProofToast from './components/SocialProofToast';
import SneakPeekBadge from './components/SneakPeekBadge';
import PackageNudge from './components/PackageNudge';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Enquire from './pages/Enquire';
import WeddingFair from './pages/WeddingFair';
import Feedback from './pages/Feedback';
import LocationLanding from './pages/LocationLanding';
import VenuesIndex from './pages/VenuesIndex';
import VenueDetail from './pages/VenueDetail';
import VenueStats from './pages/VenueStats';
import WeddingFairStats from './pages/WeddingFairStats';
import { Toaster } from './components/ui/toaster';

const HomePage = () => {
  return (
    <>
      <Navigation />
      <Hero />
      <SocialProof />
      <VenueStrip />
      <MeetAlex />
      <WhyWVE />
      <Portfolio />
      <VenueSearch />
      <Pricing id="packages" />
      <VideoReviews />
      <Testimonials id="testimonials" />
      <FAQ id="faq" />
      <DateChecker id="availability" />
      <Footer />
      <StickyMobileCTA />
      <ExitIntent />
      <SocialProofToast />
      <SneakPeekBadge />
      <PackageNudge />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/enquire" element={<Enquire />} />
          <Route path="/weddingfair" element={<WeddingFair />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/kent" element={<LocationLanding slug="kent" />} />
          <Route path="/suffolk" element={<LocationLanding slug="suffolk" />} />
          <Route path="/essex" element={<LocationLanding slug="essex" />} />
          <Route path="/london" element={<LocationLanding slug="london" />} />
          <Route path="/norfolk" element={<LocationLanding slug="norfolk" />} />
          <Route path="/wedding-videographer-kent" element={<LocationLanding slug="kent" />} />
          <Route path="/wedding-videographer-suffolk" element={<LocationLanding slug="suffolk" />} />
          <Route path="/wedding-videographer-essex" element={<LocationLanding slug="essex" />} />
          <Route path="/wedding-videographer-london" element={<LocationLanding slug="london" />} />
          <Route path="/wedding-videographer-norfolk" element={<LocationLanding slug="norfolk" />} />
          <Route path="/venues" element={<VenuesIndex />} />
          <Route path="/venues/:slug" element={<VenueDetail />} />
          <Route path="/venue-stats" element={<VenueStats /> } />
          <Route path="/wedding-fair-stats" element={<WeddingFairStats /> } />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
